// @flow

import React from "react";
import type { Product } from "../../models/Product";
import type { translate } from "../../i18next";
import { v4 as uuidv4 } from "uuid";
import "./WishlistPage.scss";
import WishlistItem from "./WishlistItem";
import WishlistShareFormContainer from "../../container/wishlist/WishlistShareFormContainer";
import EmptyWishlist from "./EmptyWishlist";
import ReactToPrint from "react-to-print";
import wishlistIcon from "../../assets/svg/outline-favorite_border-24px.svg";
import RootNodeProvider from "../../helper/RootNodeProvider";
import WelcomeMessageModal from "../layout/WelcomeMessageModal";
import {emitInternalEvent, toProductDetails} from "../../helper/tracker/internalEvents";

export type WishlistPageProps = {
	t: translate,
	products: Product[],
	hasProducts: boolean,
	removeProduct: Product => void,
	wishlistSuccess: boolean,
	wishlistError: boolean,
	resetMailing: () => void,
	isLeadModuleEnabled: boolean,
	showWelcomeMessage: boolean,
	resetWelcomeMessage: () => void,
	dealerName: string,
	dealerImageURL: string,
	fallbackImageURL: string,
	dealerAddress: string,
	dealerPhoneNumber: string,
	dealerEmail: string,
	dealerShopBaseUrl: string,
	dealerLogoUrl: string,
}

export type WishlistPageState = {
	shareModalOpen: boolean
}

class WishlistPage extends React.Component<WishlistPageProps, WishlistPageState> {
	constructor(props: WishlistPageProps) {
		super(props);
		this.state = {shareModalOpen: false};
	}

	componentDidMount() {
		emitInternalEvent("favs_view", {products: this.wishlistProductDetails()});
	}

	wishlistProductDetails = () => (this.props.products || []).map(product => toProductDetails(product));

	toggleShareModal = () => {
		if (!this.state.shareModalOpen) {
			emitInternalEvent("favs_inquiry_started", {products: this.wishlistProductDetails()});
		}
		this.setState({shareModalOpen: !this.state.shareModalOpen});
	};

	handleBeforePrint = () => {
		emitInternalEvent("favs_printed", {products: this.wishlistProductDetails()});
	};

	render() {
		return (
			<div className="hpm-wishlistPage">
				<WelcomeMessageModal
					dealerName={this.props.dealerName}
					dealerImageURL={this.props.dealerImageURL}
					fallbackImageURL={this.props.fallbackImageURL}
					showWelcomeMessage={this.props.showWelcomeMessage}
					resetWelcomeMessage={this.props.resetWelcomeMessage}
					t={this.props.t}
				/>
				{this.props.hasProducts ? (
					<div>
						{this.state.shareModalOpen ? (
							<WishlistShareFormContainer closeForm={this.toggleShareModal}/>
						) : (
							<>
								<div className="hpm-wishlistContentBox">
									<div className="hpm-wishlistContent">
										<div className="hpm-wishlistsTitle">
											<span className={"hpm-wishlistLogo"}>
												<img src={this.props.dealerLogoUrl} role={"presentation"} alt={""}/>
											</span>
											<span className={"hpm-wishlistSymbol"}>
												{/* eslint-disable */}
												<span className={"hpm-beforeWishlist"}>
													<img src={wishlistIcon} alt={""}/>
	                      </span>
												{this.props.t("bookmarks.bookmarksLabel")}
												<span className={"hpm-wishlistProductCount"}>
													{this.props.t("bookmarks.productCount", {count: this.props.products.length})}
												</span>
											</span>
											<header className={"hpm-wishlistName"}>
												{this.props.dealerName}
											</header>
										</div>
										<div className="hpm-wishlistItems">
											<header className={"hpm-wishlistLabel"}>{this.props.t("bookmarks.bookmarksLabel")}</header>
											{this.props.products.map(product => (
												<WishlistItem
													product={product}
													key={uuidv4()}
													removeProduct={this.props.removeProduct}
												/>
											))}
										</div>
										<div className={"hpm-buttonWrapper hpm-noPrint"}>
											{this.props.isLeadModuleEnabled && (
												<div className="hpm-sendButton">
													<button
														type={"button"}
														onClick={() => this.toggleShareModal()}
													>
														{this.props.t("bookmarks.sendBookmarks")}
													</button>
												</div>
											)}
											<div className="hpm-printButton">
												<ReactToPrint
													content={() => RootNodeProvider.getRootNode()}
													documentTitle={this.props.t(
														"bookmarks.bookmarksLabel"
													)}
													onBeforeGetContent={this.handleBeforePrint}
													trigger={() => (
														<button
															type="button"
														>
															{this.props.isLeadModuleEnabled ? (
																<div className={"hpm-printerIconWrapper"}>
																	<div className={"hpm-printerIcon"}/>
																	<div className={"hpm-printerText"}>
																		{this.props.t("bookmarks.print")}
																	</div>
																</div>
															) : (
																<div className={"leadModuleDisable"}>
																	{this.props.t("bookmarks.printBookmarks")}
																</div>
															)}
														</button>
													)}
												/>
											</div>
										</div>
									</div>
								</div>
								<div className={"hpm-wishlistFooter"}>
									<div className={"left"}>
										<div>{this.props.dealerPhoneNumber}</div>
										{this.props.dealerShopBaseUrl && (
											<div>{this.props.dealerShopBaseUrl}</div>
										)}
									</div>
									<div className={"right"}>
										<div>{this.props.dealerName}</div>
										<div>{`${this.props.dealerAddress.postalCode} ${this.props.dealerAddress.town}, ${this.props.dealerAddress.street} ${!!this.props.dealerAddress.streetNumber? this.props.dealerAddress.streetNumber : ""}`}</div>
									</div>
								</div>
							</>
						)}
					</div>
				) : (
					<EmptyWishlist t={this.props.t}/>
				)}
			</div>
		);
	}
}

export default WishlistPage;
